import { SelectRequest } from '@src/interface/api/request.interface'
import { ErrorResponse } from '@src/interface/api/response.interface'
import { getVendorOrderItems, ResType } from '@src/lib/api/order/getVendorOrderItems'
import { UseQueryResult, useQuery, UseQueryOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'

type ParamTypes = SelectRequest & {
	status?: string
	showUser?: boolean
	showOrderShipping?: boolean
	showTracking?: boolean
	showOrder?: boolean
	showOrderTossRecord?: boolean
	showOrderItemTracking?: boolean
}

const useGetVendorOrderItemsQuery = (
	payload: ParamTypes,
	options?: UseQueryOptions<ResType, AxiosError<ErrorResponse>, ResType>,
): UseQueryResult<ResType, AxiosError<ErrorResponse>> => {
	return useQuery<ResType, AxiosError<ErrorResponse>>(
		createKey(payload.getTotal, payload.offset),
		() => {
			return getVendorOrderItems(payload)
		},
		{
			...options,
		},
	)
}

const createKey = (getTotal?: boolean, offset?: number) => ['getVendorOrderItems', getTotal, offset]
useGetVendorOrderItemsQuery.createKey = createKey

export default useGetVendorOrderItemsQuery
